import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import usePlans from "../../../hooks/usePlans";
import useCompanies from "../../../hooks/useCompanies";
import { i18n } from "../../../translate/i18n";

export const priceLocale = () => {
  const lang = (i18n.language || "es").split("-")[0];
  if (lang === "en") return "en-US";
  if (lang === "pt") return "pt-BR";
  return "es-ES";
};

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  margin: {
    margin: theme.spacing(1),
  },


  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(8),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
    },
  },

  customCard: {
    display: "flex",
    marginTop: "16px",
    alignItems: "center",
    flexDirection: "column",
  },
  custom: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  }
}));


export default function Pricing(props) {
  const {
    setFieldValue,
    setActiveStep,
    activeStep,
  } = props;

  const { finder } = usePlans();
  const { find } = useCompanies();

  const classes = useStyles();
  const usersPlans = 3;
  const connectionsPlans = 3;
  const [storagePlans, setStoragePlans] = React.useState([]);
  const customValuePlans = 49.00;
  const companyId = localStorage.getItem("companyId");

  useEffect(() => {
    const loadPlans = async (companiesPlans) => {
      try {
        const plansCompanies = await finder(companiesPlans);
        const plans = []

        plans.push({
          title: plansCompanies.name,
          planId: plansCompanies.id,
          price: plansCompanies.value,
          description: [
            i18n.t("financial.checkout.users", { count: plansCompanies.users }),
            i18n.t("financial.checkout.connections", { count: plansCompanies.connections }),
            i18n.t("financial.checkout.queues", { count: plansCompanies.queues })
          ],
          users: plansCompanies.users,
          connections: plansCompanies.connections,
          queues: plansCompanies.queues,
          buttonText: i18n.t("financial.checkout.select"),
          buttonVariant: 'outlined',
        })

        setStoragePlans(plans);
      } catch (e) {
        console.log(e);
      }
    };

    const loadCompanies = async () => {
      try {
        const companiesList = await find(companyId);
        await loadPlans(companiesList.planId);
      } catch (e) {
        console.log(e);
      }
    };
    loadCompanies();
  }, [companyId, find, finder])


  const tiers = storagePlans
  return (
    <React.Fragment>
      <Grid container spacing={3}>
        {tiers.map((tier) => (
          // Enterprise card is full width at sm breakpoint
          <Grid item key={tier.title} xs={12} sm={tier.title === 'Enterprise' ? 12 : 12} md={12}>
            <Card>
              <CardHeader
                title={tier.title}
                subheader={tier.subheader}
                titleTypographyProps={{ align: 'center' }}
                subheaderTypographyProps={{ align: 'center' }}
                action={tier.title === 'Pro' ? <StarIcon /> : null}
                className={classes.cardHeader}
              />
              <CardContent>
                <div className={classes.cardPricing}>
                  <Typography component="h2" variant="h3" color="textPrimary">
                    {

                      <React.Fragment>
                        ${Number(tier.price || 0).toLocaleString(priceLocale(), { minimumFractionDigits: 2 })}
                      </React.Fragment>
                    }
                  </Typography>
                  <Typography variant="h6" color="textSecondary">
                    {i18n.t("financial.checkout.perMonth")}
                  </Typography>
                </div>
                <ul>
                  {tier.description.map((line) => (
                    <Typography component="li" variant="subtitle1" align="center" key={line}>
                      {line}
                    </Typography>
                  ))}
                </ul>
              </CardContent>
              <CardActions>
                <Button
                  fullWidth
                  variant={tier.buttonVariant}
                  color="primary"
                  onClick={() => {
                    if (tier.custom) {
                      setFieldValue("plan", JSON.stringify({
                        users: usersPlans,
                        connections: connectionsPlans,
                        price: customValuePlans,
                      }));
                    } else {
                      setFieldValue("plan", JSON.stringify(tier));
                    }
                    setActiveStep(activeStep + 1);
                  }
                  }
                >
                  {tier.buttonText}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  );
}